import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ParcelPropertyTaxesContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/property-taxes/content'

export const ParcelPropertyTaxesWidget: FC = () => {
  return (
    <WidgetCard
      id="property-taxes"
      title="Property Taxes"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <ParcelPropertyTaxesContent />,
        },
      ]}
    />
  )
}
